module.exports = __webpack_public_path__ + "static/media/ToDo.83f7ce07.png";